import React, { Fragment } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton } from "@mui/material";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";
import { RequestAccessLink } from "./styled/ReqModel.styled";

import {
  Data,
  HeaderCellStyle,
  StyledTableWrapper,
} from "./styled/StyledTable.styled";

function RequestModelAccessTableHead(props) {
  const { headCells, order, setOrder } = props;
  const handleChangeSort = (id) => {
    setOrder({ id: id, sort: order.sort === "asc" ? "dsc" : "asc" });
  };
  const handleChangeId = (id) => {
    setOrder({ id: id, sort: "asc" });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            align={"left"}
            sx={{ width: "fit-content", padding: "10px" }}
          >
            <HeaderCellStyle>
              {headCell.label}
              {headCell.sorting && (
                <Fragment>
                  {order.id === headCell.id ? (
                    <IconButton
                      onClick={() => {
                        handleChangeSort(headCell.id);
                      }}
                    >
                      {order.sort === "asc" && (
                        <BiUpArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                      {order.sort === "dsc" && (
                        <BiDownArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        handleChangeId(headCell.id);
                      }}
                    >
                      <BiUpArrowAlt
                        style={{
                          fontSize: "14px",
                          opacity: "0.5",
                        }}
                      />
                    </IconButton>
                  )}
                </Fragment>
              )}
            </HeaderCellStyle>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function RequestModelTable({
  headCells,
  rows,
  order,
  setOrder,
  clickOnRequestAccess,
  ...props
}) {
  return (
    <StyledTableWrapper>
      <TableContainer>
        <Table
          sx={{ minWidth: "100px", padding: "10px" }}
          aria-labelledby="tableTitle"
        >
          <RequestModelAccessTableHead
            headCells={headCells}
            order={order}
            setOrder={setOrder}
          />
          <TableBody>
            {rows.map((row, index) => {
              const labelId = `enhanced-table-row-${index}`;
              return (
                <TableRow key={labelId} hover>
                  {Object.keys(row).map((key) => {
                    if (key === "id") {
                      return null;
                    } else if (key === "model") {
                      return (
                        <TableCell align={"center"}>
                          <Data>{row[key]}</Data>
                        </TableCell>
                      );
                    } else if (Array.isArray(row[key])) {
                      return (
                        <TableCell
                          align={"left"}
                          sx={{
                            maxWidth: "200px",
                            minWidth: "100px",
                            overflowWrap: "break-word",
                          }}
                        >
                          <Data>{row[key].join(", ")}</Data>
                        </TableCell>
                      );
                    } else
                      return (
                        <TableCell align={"center"}>
                          <RequestAccessLink
                            id={row.id}
                            onClick={() => {
                              clickOnRequestAccess(row);
                            }}
                          >
                            {row[key]}
                          </RequestAccessLink>
                        </TableCell>
                      );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledTableWrapper>
  );
}
